module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/teamenvy.0826515f.png";